import axios from "axios";
import { syncServerClock } from "./serverClock";

const configuredBaseURL = (process.env.REACT_APP_API_URL || "http://localhost:4000").replace(/\/+$/, "");
const baseURL = configuredBaseURL.endsWith("/api/v1")
  ? configuredBaseURL
  : `${configuredBaseURL}/api/v1`;

const api = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Seeds the server clock before the socket's first frame. A cacheable response
// may be served from the browser cache with its old `Date`, so it is skipped.
api.interceptors.response.use((response) => {
  if (!/max-age/.test(response.headers?.["cache-control"] || "")) {
    syncServerClock(Date.parse(response.headers?.date));
  }
  return response;
});

const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default api;
